module.exports = __webpack_public_path__ + "static/WindingWorlds2-990f2b9ef44a122250b66f0d6d6c2ca0.webp";